import React from 'react';
import { useDispatch } from 'react-redux';
import { Alert } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import * as auth from "../_redux/authRedux";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function SSO() {
  const dispatch = useDispatch();
  let query = useQuery();
  let token = query.get('token');
  let assumeId = query.get('assume_id');
  if (token) {
    dispatch(auth.actions.setInitialStateLogout());
    localStorage.setItem("temp_token", token);
    let redirect_url = query.get('redirect_url');
    localStorage.setItem("assume_id", assumeId);
    // redirect_url && localStorage.setItem("redirect_url", redirect_url);
    setTimeout(() => { window.location = "/ssologin"; }, 100);
    // window.location = `/sso?token=${token}&redirect_url=${redirect_url}`;
    // history.push("/#");
    // window.location.reload();
  }

  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-4">
          <div className="text-center mt-20">
            <Alert variant="primary">
              <h3>{`Redirecting to SSO Login`}</h3>
            </Alert>
          </div>
        </div>
      </div>
    </div>
  );
}
